import React, { useState } from "react";

const UniversalButton = ({ children, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      className="btn w-100 mt-3 shadow"
      style={{
        backgroundColor: isHovered ? "#1e519d" : "#212529",
        color: "#fff",
        transition: "all 0.3s ease",
        transform: isHovered ? "scale(1.03)" : "scale(1)",
        boxShadow: isHovered
          ? "0 4px 12px rgba(0, 0, 0, 0.25)"
          : "0 2px 4px rgba(0, 0, 0, 0.15)",
        borderRadius: "6px",
      }}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </button>
  );
};

export default UniversalButton;
